import axios from 'axios';
import environment from 'constants/apiConst';

export const __Get_Items__EntryFmm = async (token, data) => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    },
    data: data || ""
  };

  const res = await axios(environment.GET_ENTRY_ITEMS, options);
  return res;
};

export const __Get_Items__ExitsFmm = async (token, data) => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    },
    data: data || ""
  };

  const res = await axios(environment.GET_EXIT_ITEMS, options);
  return res;
};
